import { CaseVoucherSource, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { pickedDayIn, startOfPickedDayIn, } from '@debbie/common/dist/economy/helpers/engine-v2/dates.js';
import { countedAmounts, isPayment, } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { CountryCode, Entity, Site, formatNumber, } from '@debbie/common/dist/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { toDecimal, toPercent } from '../../../utils/index.js';
import Alert from '../../Alert.js';
import Button from '../../Button.js';
import Checkbox from '../../Checkbox.js';
import ContactSelect, { hasBankAccount } from '../../ContactSelect.js';
import DateInput from '../../DateInput.js';
import File from '../../File/index.js';
import FileDropzone from '../../FileDropzone.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import Input from '../../Input.js';
import MoneyInput from '../../MoneyInput.js';
import NewEntityProperties from '../../Properties/NewEntityProperties.js';
import SearchInput from '../../SearchInput.js';
let tid;
const VoucherTypeSettingsWithInterestRate = [
    VoucherTypeSetting.CompoundInterest,
    VoucherTypeSetting.InterestPercentage,
];
const CostVoucherCreator = (props) => {
    const { voucherType } = props;
    const addInterest = voucherType.editorSettings.addInterest;
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const site = useSelector((s) => s.site);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const voucherTypesLoader = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoader)
        ? voucherTypesLoader.data
        : null;
    const [amount, setAmount] = useState(voucherType.editorSettings.defaultAmount || NaN);
    const [date, setDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(null);
    const [source, setSource] = useState(voucherType.editorSettings.defaultSource ||
        CaseVoucherSource.Collector);
    const [text, setText] = useState(undefined);
    const [contactId, setContactId] = useState(null);
    const [billCreditor, setBillCreditor] = useState(false);
    // A cost the creditor imposed is already paid by the creditor, so neither a
    // payout nor a creditor disbursement applies
    const collectorOutlay = source === CaseVoucherSource.Collector;
    const payoutToContact = voucherType.editorSettings.payoutToContact === true && collectorOutlay;
    const creditorDisbursement = voucherType.editorSettings.creditorDisbursement;
    const disbursementVoucherType = creditorDisbursement != null && collectorOutlay && site !== Site.Client
        ? objectBy(voucherTypes ?? [], (type) => type.voucherTypeId)[creditorDisbursement.voucherTypeId]
        : undefined;
    const disbursementRequired = creditorDisbursement?.required === true;
    const disbursementLabel = disbursementVoucherType != null
        ? lang.economyVoucherTypeLabels[disbursementVoucherType.voucherTypeId] ||
            disbursementVoucherType.label
        : null;
    const [properties, setProperties] = useState(null);
    const [referenceId, setReferenceId] = useState(undefined);
    const [referenceVoucher, setReferenceVoucher] = useState(null);
    const [appendix, setAppendix] = useState(null);
    const [associate, setAssociate] = useState(false);
    const [interest, setInterest] = useState(NaN);
    const [interestEndDate, setInterestEndDate] = useState(null);
    const [withInterest, setWithInterest] = useState(addInterest && site !== Site.Client);
    const [referenceCaseVoucherInterest, setReferenceCaseVoucherInterest] = useState(NaN);
    const [referenceCaseVoucherInterestStartDate, setReferenceCaseVoucherInterestStartDate,] = useState(moment().add(31, 'days').toDate());
    const [referenceCaseVoucherInterestEndDate, setReferenceCaseVoucherInterestEndDate,] = useState(null);
    const [referenceCaseVoucherInterestSource, setReferenceCaseVoucherInterestSource,] = useState(CaseVoucherSource.Collector);
    const [referenceInterestStartDateManualSet, setReferenceInterestStartDateManualSet,] = useState(false);
    const [dropzone, setDropzone] = useState(null);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dateChanged, setDateChanged] = useState(null);
    const [duplicates, setDuplicates] = useState(null);
    const interestType = props.voucherType.voucherTypeId === VoucherTypeIds.GAELDSBREV ||
        !(tenant && [CountryCode.DK, CountryCode.GL].includes(tenant.countryCode))
        ? VoucherTypeIds.YEARLYINTEREST
        : tenant?.countryCode === CountryCode.GL
            ? VoucherTypeIds.GLPROCESSINTEREST
            : VoucherTypeIds.PROCESSINTEREST;
    const interestVoucherType = h.hasData(voucherTypesLoader)
        ? voucherTypesLoader.data.find((type) => type.voucherTypeId === interestType)
        : undefined;
    const interestTypeHasRate = interestVoucherType?.setting != null &&
        VoucherTypeSettingsWithInterestRate.includes(interestVoucherType.setting);
    useEffect(() => {
        // If date is changed manually, don't update it by OCR scanning the PDF
        setDateChanged(dateChanged !== null);
    }, [date]);
    const checkForDuplicates = async () => {
        if (singleCase && referenceId && voucherType.voucherTypeId) {
            const matches = await caseVouchersAPI.checkForDuplicates(singleCase.creditorId, [
                {
                    referenceId: referenceId,
                    voucherTypeId: voucherType.voucherTypeId,
                },
            ]);
            setDuplicates(matches);
        }
    };
    useEffect(() => {
        clearTimeout(tid);
        setDuplicates(null);
        tid = setTimeout(() => checkForDuplicates(), 500);
    }, [referenceId]);
    const isAccumulatingInterest = voucherType.setting &&
        [
            VoucherTypeSetting.CompoundInterest,
            VoucherTypeSetting.InterestFromTable,
            VoucherTypeSetting.InterestPercentage,
        ].includes(voucherType.setting);
    const referenceCaseVoucherRequired = voucherType.editorSettings.referenceCaseVoucherRequired ||
        isAccumulatingInterest;
    const canSubmit = !!date &&
        (voucherType.setting &&
            VoucherTypeSettingsWithInterestRate.includes(voucherType.setting)
            ? !Number.isNaN(interest)
            : true) &&
        (withInterest === true
            ? h.hasData(voucherTypesLoader) &&
                (!interestTypeHasRate || !Number.isNaN(referenceCaseVoucherInterest))
            : true) &&
        (isAccumulatingInterest ? true : Number.isInteger(amount)) &&
        // Due date required
        (voucherType.editorSettings.dueDateRequired ? !!dueDate : true) &&
        // Reference id required
        (voucherType.editorSettings.referenceIdRequired ? !!referenceId : true) &&
        // VoucherTypeSetting.TextAsLabel then text is required
        (voucherType.setting === VoucherTypeSetting.TextAsLabel ? !!text : true) &&
        // reference voucher required
        (referenceCaseVoucherRequired ? !!referenceVoucher : true) &&
        // reference voucher required
        (voucherType.editorSettings.appendixRequired ? !!appendix : true) &&
        // contact to pay out to required
        (payoutToContact ? contactId != null : true);
    const createVoucher = async () => {
        if (!canSubmit || tenant == null) {
            return;
        }
        const tenantDay = startOfPickedDayIn(tenant.timezone);
        setLoading(true);
        await props.onCreate({
            voucherTypeId: voucherType.voucherTypeId,
            amount: (voucherType.editorSettings.amountNegative ? amount : -amount) || 0,
            referenceId,
            date: tenantDay(date),
            dueDate: dueDate != null && voucherType.editorSettings.dueDateInput
                ? tenantDay(dueDate)
                : undefined,
            source: Site.Client === site ? CaseVoucherSource.Creditor : source,
            properties: properties || undefined,
            text: text != null && text !== '' ? text : undefined,
            referenceCaseVoucherId: referenceVoucher?.caseVoucherId || undefined,
            appendix,
            interest: voucherType.setting &&
                VoucherTypeSettingsWithInterestRate.includes(voucherType.setting)
                ? interest
                : undefined,
            interestStartDate: tenantDay(date),
            interestEndDate: interestEndDate != null ? tenantDay(interestEndDate) : null,
            referenceCaseVouchers: withInterest
                ? [
                    {
                        voucherTypeId: interestType,
                        amount: 0,
                        date: tenantDay(referenceCaseVoucherInterestStartDate),
                        interestStartDate: tenantDay(referenceCaseVoucherInterestStartDate),
                        interestEndDate: referenceCaseVoucherInterestEndDate != null
                            ? tenantDay(referenceCaseVoucherInterestEndDate)
                            : null,
                        interest: interestTypeHasRate
                            ? referenceCaseVoucherInterest
                            : undefined,
                        source: referenceCaseVoucherInterestSource,
                    },
                ]
                : [],
            associationId: associate && singleCase?.associationId
                ? crypto.randomUUID()
                : undefined,
            contactId,
            billCreditor,
        });
        setLoading(false);
    };
    const searchVouchers = useMemo(() => {
        const sv = props.caseVouchers.filter((cV) => !cV.referenceCaseVoucherId);
        sv.sort((a, b) => {
            if (a.category === b.category) {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            }
            return (CaseVoucherCategories.indexOf(a.category) -
                CaseVoucherCategories.indexOf(b.category));
        });
        return sv;
    }, [props.caseVouchers]);
    return (React.createElement(Wrapper, null,
        singleCase?.associationId &&
            !isPayment(voucherType) &&
            voucherType.voucherTypeId !== VoucherTypeIds.CREDITNOTE && (React.createElement(Checkbox, { placeholder: React.createElement(React.Fragment, null,
                React.createElement(AssociationIcon, { style: { margin: '0.2em 0 -0.2em' } }),
                ' ',
                lang.associateCases.associateCaseVoucher), checked: associate, onChange: (e) => setAssociate(e.target.checked), setting: true })),
        voucherType.editorSettings.appendixInput && (React.createElement(FileDropzone, { setLoading: setUploadingFile, onChange: (file) => {
                setAppendix({
                    contentType: file?.contentType,
                    fileId: file?.fileId,
                    fileName: file?.fileName,
                });
                const invoiceEntities = file?.meta?.parsedInvoice?.entities || [];
                // voucher.referenceId
                const invoiceReferenceId = invoiceEntities.find((entity) => entity.type === 'invoice_id')?.mentionText;
                if (invoiceReferenceId && !referenceId) {
                    setReferenceId(invoiceReferenceId);
                }
                // voucher.amount
                const invoiceAmount = invoiceEntities.find((entity) => entity.type === 'total_amount')?.normalizedValue?.text;
                if (invoiceAmount && !amount) {
                    setAmount(Math.round(parseFloat(invoiceAmount) * 100));
                }
                // voucher.date
                const invoiceDate = invoiceEntities.find((entity) => entity.type === 'invoice_date')?.normalizedValue?.text;
                if (invoiceDate && !dateChanged) {
                    const _date = moment(invoiceDate, 'YYYY-MM-DD');
                    setDate(_date.toDate());
                    setReferenceCaseVoucherInterestStartDate(_date.add(31, 'days').toDate());
                }
                // voucher.dueDate
                const invoiceDueDate = invoiceEntities.find((entity) => entity.type === 'due_date')?.normalizedValue?.text;
                if (invoiceDueDate && !dueDate) {
                    setDueDate(moment(invoiceDueDate, 'YYYY-MM-DD').toDate());
                }
            }, dropzoneRef: (r) => {
                setDropzone(r);
            }, parseInvoice: true, style: {
                padding: '40px',
                border: '3px dashed lightgray',
                marginBottom: '20px',
            } }, appendix != null ? (React.createElement(File, { style: { marginBottom: '20px' }, onRemove: () => setAppendix(null), removable: true, file: appendix })) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { style: {
                    marginBottom: '0px',
                    margin: '0 auto',
                    display: 'block',
                }, onClick: () => {
                    if (dropzone != null) {
                        dropzone.open();
                    }
                }, size: "small", theme: "secondary", loading: uploadingFile }, lang.economy.addAppendix))))),
        duplicates && !!duplicates.length && (React.createElement(Alert, { message: React.createElement(React.Fragment, null,
                lang.economyVoucherTypeLabels[voucherType.voucherTypeId],
                ' ',
                referenceId,
                " ",
                lang.economy.voucherAlreadyExists,
                ' ',
                duplicates.map((match, index) => (React.createElement(React.Fragment, null,
                    React.createElement(Link, { style: {
                            color: 'inherit',
                        }, to: `/cases/${match.caseSeqId}` }, match.caseSeqId),
                    duplicates.length - 1 !== index && ', ')))) })),
        (voucherType.editorSettings.referenceCaseVoucherInput ||
            referenceCaseVoucherRequired) && (React.createElement(SearchInput, { resultsStyle: { maxHeight: '160px' }, placeholder: lang.economy.referenceVoucher, forceOpen: true, searchAll: (q) => {
                return searchVouchers
                    .filter((v) => [
                    VoucherCategory.PRINCIPAL,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.COST,
                ].includes(v.category) &&
                    (`${v.label} (${formatNumber(countedAmounts(v).amount)})`
                        .toLocaleLowerCase()
                        .includes(q.toLocaleLowerCase()) ||
                        !q))
                    .filter((v) => countedAmounts(v).amount < 0)
                    .map((v) => ({
                    key: v.caseVoucherId,
                    heading: (React.createElement(SearchWrapper, null,
                        React.createElement("span", null,
                            // @ts-ignore
                            lang.economyVoucherTypeLabels[v.voucherTypeId] ||
                                v.label,
                            ' ',
                            v.referenceId),
                        React.createElement("span", null, formatNumber(Math.abs(countedAmounts(v).amount))))),
                    subheading: lang.economyCategories[v.category],
                    returnData: v,
                }));
            }, onSelect: (v) => {
                // If interest set interest start date to 31 days after voucher date
                if ((isAccumulatingInterest ||
                    voucherType.setting === VoucherTypeSetting.FixedInterest) &&
                    !dateChanged &&
                    tenant != null) {
                    setDate(moment(pickedDayIn(tenant.timezone)(v.date))
                        .add(31, 'days')
                        .toDate());
                }
                setReferenceVoucher(v);
            }, onRemoveStatic: () => setReferenceVoucher(null), static: (referenceVoucher &&
                `${
                // @ts-ignore
                lang.economyVoucherTypeLabels[referenceVoucher.voucherTypeId] ||
                    referenceVoucher.label} ${referenceVoucher.referenceId ?? ''} (${formatNumber(Math.abs(countedAmounts(referenceVoucher).amount))})`) ||
                null })),
        voucherType.editorSettings.referenceIdInput && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.referenceId, value: referenceId != null ? referenceId : '', onChange: (e) => {
                setReferenceId(e.target.value);
            }, onBlur: () => checkForDuplicates() })),
        (voucherType.setting === VoucherTypeSetting.TextAsLabel ||
            voucherType.editorSettings.textInput) && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.text, value: text != null ? text : '', onChange: (e) => {
                setText(e.target.value);
            } })),
        React.createElement(OneLine, null,
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: isAccumulatingInterest ||
                        voucherType.setting === VoucherTypeSetting.FixedInterest
                        ? lang.economy.interestStartDate
                        : lang.economy.date, allowNull: false, value: moment(date), onChange: (d) => {
                        setDate(d.toDate());
                        if (!referenceInterestStartDateManualSet) {
                            setReferenceCaseVoucherInterestStartDate(moment(d).add(31, 'days').toDate());
                        }
                    } })),
            (isAccumulatingInterest ||
                voucherType.setting === VoucherTypeSetting.FixedInterest) && (React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.economy.interestEndDate, value: interestEndDate != null ? moment(interestEndDate) : undefined, allowNull: false, onChange: (d) => {
                        setInterestEndDate(d.toDate());
                    } }))),
            voucherType.editorSettings.dueDateInput && (React.createElement(InputWrapper, null,
                React.createElement(DateInput, { placeholder: lang.economy.dueDate, value: dueDate != null ? moment(dueDate) : undefined, allowNull: true, onChange: (d) => {
                        setDueDate(d?.toDate() || null);
                    }, minDate: date ? moment(date).startOf('day').toDate() : undefined })))),
        voucherType.setting &&
            VoucherTypeSettingsWithInterestRate.includes(voucherType.setting) && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.interestRate, type: "number", value: !Number.isNaN(interest) ? toPercent(interest) : '', onChange: (e) => {
                setInterest(toDecimal(parseFloat(e.target.value)));
            } })),
        !isAccumulatingInterest && (React.createElement(MoneyInput, { value: amount, onChange: (c) => setAmount(Math.abs(c)), placeholder: lang.economy.amount })),
        voucherType.editorSettings.sourceInput && site !== Site.Client && (React.createElement(Checkbox, { placeholder: lang.economy.imposedByCreditor, onChange: (e) => setSource(e.target.checked
                ? CaseVoucherSource.Creditor
                : CaseVoucherSource.Collector), checked: source === CaseVoucherSource.Creditor })),
        payoutToContact && (React.createElement(ContactSelect, { value: contactId, filter: hasBankAccount, placeholder: lang.contacts.selectPayoutContact, onChange: (id) => setContactId(id) })),
        disbursementLabel != null &&
            (disbursementRequired ? (React.createElement(Statement, null,
                lang.economy.disbursementAddedToBilling,
                " (",
                disbursementLabel,
                ")")) : (React.createElement(Checkbox, { placeholder: `${lang.economy.addDisbursementToBilling} (${disbursementLabel})`, checked: billCreditor, onChange: (e) => setBillCreditor(e.target.checked) }))),
        addInterest && (React.createElement(Checkbox, { placeholder: lang.economy.voucherCreationIncludeInterest, checked: withInterest, onChange: (e) => setWithInterest(e.target.checked), setting: true })),
        withInterest && (React.createElement(React.Fragment, null,
            interestTypeHasRate && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.interestRate, type: "number", value: !Number.isNaN(referenceCaseVoucherInterest)
                    ? toPercent(referenceCaseVoucherInterest)
                    : '', onChange: (e) => {
                    setReferenceCaseVoucherInterest(toDecimal(parseFloat(e.target.value)));
                } })),
            React.createElement(OneLine, null,
                React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.economy.interestStartDate, value: moment(referenceCaseVoucherInterestStartDate), allowNull: false, onChange: (d) => {
                            setReferenceInterestStartDateManualSet(true);
                            setReferenceCaseVoucherInterestStartDate(d.toDate());
                        } })),
                React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.economy.interestEndDate, value: referenceCaseVoucherInterestEndDate != null
                            ? moment(referenceCaseVoucherInterestEndDate)
                            : undefined, allowNull: false, onChange: (d) => {
                            setReferenceCaseVoucherInterestEndDate(d.toDate());
                        } }))),
            voucherType.voucherTypeId !== VoucherTypeIds.INVOICE &&
                voucherType.voucherTypeId !== VoucherTypeIds.GAELDSBREV && (React.createElement(Checkbox, { placeholder: lang.economy.imposedByCreditor, onChange: (e) => setReferenceCaseVoucherInterestSource(e.target.checked
                    ? CaseVoucherSource.Creditor
                    : CaseVoucherSource.Collector), checked: referenceCaseVoucherInterestSource ===
                    CaseVoucherSource.Creditor })))),
        !voucherType.editorSettings.hideProperties && (React.createElement(NewEntityProperties, { propRef: Entity.CaseVoucher, caseGroupId: singleCase?.caseGroup?.id ?? null, onChange: (p) => {
                let exists = false;
                setProperties(properties && properties.length > 0
                    ? properties
                        .map((prop) => {
                        if (prop.handle === p.handle) {
                            exists = true;
                            return p;
                        }
                        else {
                            return prop;
                        }
                    })
                        .concat(exists ? [] : [p])
                    : [p]);
            } })),
        React.createElement(Button, { disabled: !canSubmit, style: { width: '100%' }, loading: loading, onClick: createVoucher },
            lang.economy.voucherCreationCreate,
            ' ',
            lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                voucherType?.label)));
};
export default CostVoucherCreator;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const OneLine = styled.div `
  display: flex;
`;
const Statement = styled.p `
  margin: 0 0 10px;
  font-size: 0.9em;
  color: ${THEME.COLOR_GREY};
`;
const DateWrapper = styled.div `
  width: 100%;
  margin-right: 20px;
`;
const InputWrapper = styled.div `
  width: 100%;
`;
const SearchWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=CaseVoucherCreator.js.map